import { motion } from "framer-motion";
import ShareCard from "./ShareCard";
import ReferralLink from "./ReferralLink";

const EASE = [0.16, 1, 0.3, 1];

export default function SuccessCard({ result, onDismiss }) {
  const isFounding = result.founding_number != null;
  const missedFounding = result.foundingRequested && result.founding_number == null;
  const hasNumbers = result.waitlist_position != null;

  const title = result.existing
    ? "You are already on the list."
    : isFounding
      ? "Welcome to the Founding Community."
      : "You are on the waitlist.";

  const badge = isFounding
    ? `FOUNDING SEAT #${String(result.founding_number).padStart(3, "0")} / 200`
    : hasNumbers
      ? `POSITION #${result.waitlist_position}`
      : "ENTRY RECEIVED";

  const instructions = result.existing
    ? "This email and phone number are already registered. Your numbers are above."
    : isFounding
      ? "Your founding number is permanent and never reissued. You will hear from us before anyone else."
      : "You will be the first to know when the first drop opens.";

  return (
    <motion.div
      data-testid="waitlist-success-modal"
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7, ease: EASE }}
      className="rounded-[28px] border-2 border-[#F3B9CD] bg-white p-10 shadow-[10px_10px_0_#FDE7EF] sm:p-12"
    >
      <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#171512]/50">confirmed</p>
      <h3 className="mt-6 font-sans text-3xl font-semibold leading-[1.1] tracking-tight text-[#171512] sm:text-4xl">
        {title}
      </h3>

      {hasNumbers && (
        <p
          data-testid="waitlist-success-position-number"
          className="mt-8 font-mono text-base tracking-[0.14em] text-[#B9822E] sm:text-xl"
        >
          {badge}
        </p>
      )}

      {isFounding && result.waitlist_position != null && (
        <p className="mt-2 font-mono text-[11px] tracking-[0.18em] text-[#171512]/50">
          WAITLIST POSITION #{result.waitlist_position}
        </p>
      )}

      {missedFounding && (
        <p data-testid="founding-full-note" className="mt-4 font-mono text-[11px] tracking-[0.08em] text-[#171512]/50">
          The 200 founding seats are fully allocated. Your waitlist position is secured.
        </p>
      )}

      <p className="mt-6 max-w-md text-sm leading-[1.8] text-[#171512]/65">{instructions}</p>

      {isFounding && <ShareCard seatNumber={result.founding_number} />}

      {hasNumbers && !result.existing && <ReferralLink position={result.waitlist_position} />}

      <button
        data-testid="waitlist-success-dismiss-button"
        onClick={onDismiss}
        className="mt-10 rounded-full border border-[#171512]/25 px-6 py-3 font-mono text-[11px] font-medium uppercase tracking-[0.2em] text-[#171512] transition-colors duration-200 hover:border-[#171512] hover:bg-[#FBE9EE]"
      >
        back
      </button>
    </motion.div>
  );
}
